import React, { useState, useEffect } from 'react';

/* ── Scroll-to-top button ── */
export const ScrollTopButton = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handle = () => setVisible(window.scrollY > 500);
    window.addEventListener('scroll', handle);
    return () => window.removeEventListener('scroll', handle);
  }, []);

  if (!visible) return null;

  return (
    <button
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      title="Back to top"
      style={{
        position: 'fixed',
        bottom: 32, right: 32,
        zIndex: 999,
        width: 50, height: 50,
        borderRadius: 12,
        border: 'none',
        background: 'linear-gradient(135deg,#c9a227,#e8c040)',
        color: '#0a0a0a',
        fontSize: 20,
        cursor: 'pointer',
        boxShadow: '0 8px 24px rgba(201,162,39,0.5)',
        transition: 'all 0.3s',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
      }}
      onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-3px) scale(1.05)'; }}
      onMouseLeave={(e) => { e.currentTarget.style.transform = ''; }}
    >
      ↑
    </button>
  );
};

/* ── WhatsApp floating button ── */
export const WhatsAppButton = () => (
  <a
    href="https://wa.me/91XXXXXXXXXX"
    target="_blank"
    rel="noopener noreferrer"
    title="Chat on WhatsApp"
    style={{
      position: 'fixed',
      bottom: 92, right: 32,
      zIndex: 999,
      width: 50, height: 50,
      borderRadius: 12,
      background: '#25d366',
      color: '#fff',
      fontSize: 22,
      textDecoration: 'none',
      boxShadow: '0 8px 24px rgba(37,211,102,0.5)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      transition: 'all 0.3s',
      animation: 'pulse 3s infinite',
    }}
    onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-3px) scale(1.05)'; }}
    onMouseLeave={(e) => { e.currentTarget.style.transform = ''; }}
  >
    💬
  </a>
);
